/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Safe_Swift_Bat_SpinInputs */

const en_safe_swift_bat_spin = /** @type {(inputs: Safe_Swift_Bat_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoters`)
};

const de_safe_swift_bat_spin = /** @type {(inputs: Safe_Swift_Bat_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotoren`)
};

/**
* | output |
* | --- |
* | "Promoters" |
*
* @param {Safe_Swift_Bat_SpinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const safe_swift_bat_spin = /** @type {((inputs?: Safe_Swift_Bat_SpinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_Swift_Bat_SpinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_safe_swift_bat_spin(inputs)
	return de_safe_swift_bat_spin(inputs)
});